import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { UsersSearchParameters } from '@src/api';
import { GroupInfoService } from '@src/app/modules/group-info';
import { ViewMode, GroupUI } from '@src/models';

import { TelegramMessengerService } from '../../services/telegram-messenger.service';

@Component({
  selector: 'app-group-info-telegram',
  templateUrl: './group-info-telegram.component.html',
  styleUrls: ['./group-info-telegram.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupInfoTelegramComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly groupInfoService = inject(GroupInfoService);
  private readonly messengerService = inject(TelegramMessengerService);

  @Input() mode: ViewMode = 'view';
  @Input() type?: 'organisation' | 'committee';
  @Input() data?: GroupUI;
  @Input() isChannel: boolean = false;
  @Input() organisationId?: string;
  @Input() initFilter?: UsersSearchParameters;
  @Input() allowSubscribing?: boolean | null = false;
  @Input() allowSpecialFieldsViewing?: boolean | null = false;
  @Output() saved = new EventEmitter<GroupUI>();
  @Output() canceled = new EventEmitter<void>();
  @Output() deleted = new EventEmitter<string>();

  loading: boolean = false;

  async create(data: GroupUI) {
    this.loading = true;

    const newGroupData = await this.groupInfoService.createGroup(data);
    if (newGroupData) {
      data = newGroupData;
      this.messengerService.getAllChatIds(true);
      this.mode = 'view';
      this.saved.emit(data);
    }

    this.loading = false;
    this.cdr.markForCheck();
  }

  async edit(data: GroupUI) {
    this.loading = true;

    await this.groupInfoService.editGroup(data);

    this.mode = 'view';
    this.loading = false;
    this.cdr.markForCheck();
    this.saved.emit(data);
  }
}
